import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const LogicFamilies_DigitalGates_TTL_CMOS = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Logic Families: Digital Logic Gates, TTL and CMOS logic families."
    videos={[
      "https://www.youtube.com/embed/f3zRz0d9XA8?list=PLwjK_iyK4LLDekRGPYyDZC0uCv844g4x4",
      "https://www.youtube.com/embed/zP8w-RXQK4Q?list=PLwjK_iyK4LLDekRGPYyDZC0uCv844g4x4"
    ]}
    takeaways={[
      { text: "From these topics focus more on the CMOS logic and implementation of CMOS logic" },
      { text: "For the remaining topics focus on theory" }
    ]}
    questions={[
      "Explain with an example how digital gates are implemented using CMOS technology",
      "Draw the CMOS logic circuit for the following Boolean expression F=(AB+CD)'"
    ]}
    exampleVideos={[]}
  />
);
}

export default LogicFamilies_DigitalGates_TTL_CMOS;
